import type { ActiveSalesLead } from '@/api/customerProfile/types/salesLeads.ts';
import Division from '@/entities/Division.js';
import LeadType from '@/entities/LeadType.js';

export type CustomerLeadIdentity = {
    name: string;
    business: boolean;
    businessName: string;
    civility: string | null;
    phone: string;
    email: string;
};

type AddLeadResult = Record<string, unknown>;

const customerIdentityFields = (identity: CustomerLeadIdentity): AddLeadResult => ({
    first_name: '',
    last_name: identity.name,
    business: identity.business,
    business_name: identity.businessName,
    civility: identity.civility,
    phones: identity.phone ? [{ number: identity.phone, type: 'home', preferred: true }] : [],
    emails: identity.email
        ? [
              {
                  address: identity.email,
                  email: identity.email,
                  type: 'home',
                  preferred: true,
              },
          ]
        : [],
});

const sourceFields = (source: string | null, sourceId: number | null): AddLeadResult => ({
    source: source ? { id: sourceId, name: source } : null,
    source_id: sourceId,
});

export const adaptCustomerSalesLeadResult = (
    lead: ActiveSalesLead,
    identity: CustomerLeadIdentity
): AddLeadResult => {
    const { vehicles, exchange_vehicles: exchangeVehicles, ...leadFields } = lead;

    return {
        ...leadFields,
        ...customerIdentityFields(identity),
        ...sourceFields(lead.source, lead.source_id),
        division_id: Division.getByName(lead.division),
        lead_type_id: LeadType.getValue(lead.type),
        status: lead.status === 'active' ? null : lead.status,
        user_id: lead.assignees.advisor?.id ?? null,
        bdc_user_id: lead.assignees.bdc_agent?.id ?? null,
        second_user_id: lead.assignees.second_associate?.id ?? null,
        vehicles: [
            ...vehicles.map((vehicle) => ({ ...vehicle, type: 'wanted' })),
            ...exchangeVehicles.map((vehicle) => ({ ...vehicle, type: 'exchange' })),
        ],
    };
};
